<template>
    <div class="feedback-step">
        <b-field>
            <b-input type="textarea"
                     class="feedback-textarea"
                     v-model="feedbackText"
                     :placeholder="placeholder"></b-input>
        </b-field>
    </div>
</template>

<script>
    export default {
        name: "StepAddFeedback",
        props: {
            feedback: {
            }
        },
        data() {
            return {
                feedbackText: '',
                placeholder: 'Please add some feedback',
                questionType: this.$attrs['feedback-data'].type.id
            }
        },
        mounted() {
            this.feedbackText = this.feedback;
        },
        computed: {
            stepResult() {
                return {
                    feedbackText: this.feedbackText
                }
            }
        },
        watch: {
            feedbackText() {
                if (this.questionType === 5 || this.questionType === 7) {
                    if (this.feedbackText.trim() !== '')
                        this.$emit('updateProgress', true)
                    else {
                        this.$emit('updateProgress', false)
                    }
                }
            }
        },
    }
</script>

<style scoped>

</style>
